<template>
  <section>
    <PageTitle title="Invoice" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/restaurant_billings',title:'Billings And Subscriptions'},{href:'/view_pending_invoices',title:'Pending Invoice'}]" />
    <div class="row">
      <div class="col-lg-12">
        <div class="wrapper wrapper-content animated fadeInRight">
          <div class="ibox-content p-xl">
            <div  id="print-div">
              <div class="row text-center">
                <h1><b>Delivery Monster</b></h1>
              </div>
              <div class="row">
                <div class="col-sm-8">
                  <address>
                    <strong>{{selectedRestaurant.name}}</strong><br>
                    Name: {{selectedRestaurant.billingName}}<br>
                    Address: {{selectedRestaurant.billingAddress}}<br>
                    <abbr title="Phone">Phone No:</abbr> {{selectedRestaurant.billingContactNumber}}
                  </address>
                </div>
              </div>

              <div class="table-responsive m-t">
                <table class="table invoice-table">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Subscription Name</th>
                    <th>Invoice Id</th>
                    <th>Total Billed Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="InvoiceStats in pendingInvoicesDetails" v-bind:key="InvoiceStats.id">
                      <td>
                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" :value="InvoiceStats.id" v-model="selectedInvoicesIds">
                      </td>
                      <td><div><strong>DVM Standard Subscription</strong></div></td>
                      <td>{{InvoiceStats.id}}</td>
                      <td>{{InvoiceStats.billedAmount}}</td>
                    </tr>
                  </tbody>
                </table>

                <button @click="updatePendingInvoicesStatus()" class="btn btn-primary pull-right">Pay Now</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";
export default {
  name: "ViewPendingInvoices",
  components: {PageTitle},
  data(){
    return {
      pendingInvoices: "",
      selectedRestaurant: [],
      pendingInvoicesDetails: [],
      selectedInvoicesIds: [],
    }
  },
  mounted() {
    if (this.$route.query.stats !== undefined) {
      this.pendingInvoicesDetails= JSON.parse(this.$route.query.stats);
    }
    if (this.$route.query.res !== undefined) {
      let restaurant_id= this.$route.query.res;
      let params1= new URLSearchParams();
      params1.append("restaurant_id", restaurant_id);
      this.$http.post(this.$store.state.mainAppURL + "restaurants/get_restaurant_by_id", params1).then(resp => {
        this.selectedRestaurant = resp.data;
      });
    }
  },
  methods: {
    updatePendingInvoicesStatus: function () {
      if(this.selectedInvoicesIds.length>0)
        this.$router.replace("/restaurant_billings?update="+JSON.stringify(this.selectedInvoicesIds)+"&res="+this.selectedRestaurant.id);
      else
        this.$router.replace("/restaurant_billings?res="+this.selectedRestaurant.id);
    },
  }
}
</script>

<style scoped>
.margin {
  margin-left: 5px;
}